export const CONTACT_EMAIL = 'hello@reinventsoftware.io';
export const SITE_TITLE = 'Reinvent Software';



// WEBPACK FOOTER //
// ./src/app/const.js